import { GET_ADVANCED_SEARCH_FAILURE, GET_ADVANCED_SEARCH_REQUEST, GET_ADVANCED_SEARCH_SUCCESS } from "constants/actionTypes";

const intialState = {
  data: {} as any,
  loading: false,
  error: null
};

const getAdvancedSearch = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_ADVANCED_SEARCH_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_ADVANCED_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      };
    case GET_ADVANCED_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.payload.message
      };
    default:
      return state;
  }
};

export default getAdvancedSearch;
